var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141636",
    "data-name": "Rectangle 141636",
    width: 34,
    height: 38,
    transform: "translate(0.329 0.401)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69000",
    "data-name": "Group 69000",
    transform: "translate(-0.329 -0.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68998",
    "data-name": "Group 68998",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85964",
    "data-name": "Path 85964",
    d: "M81.411,508.44c0,.209-6,.378-13.391.378s-13.391-.169-13.391-.378,6-.378,13.391-.378,13.391.169,13.391.378",
    transform: "translate(-50.534 -469.708)",
    fill: "#d8dfea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85965",
    "data-name": "Path 85965",
    d: "M310.464,40.64v3.675a10.807,10.807,0,0,1-10.8,10.809h-1.512l1.679-1.732a9.087,9.087,0,0,0,8.908-9.077V41.5h-6.482l.216-1.729h7.13a.864.864,0,0,1,.864.865",
    transform: "translate(-275.524 -37.054)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85966",
    "data-name": "Path 85966",
    d: "M167.408,293.9v1.909H156.173V293.9a.431.431,0,0,1,.22-.376l.851-.48a4.683,4.683,0,0,0,2.385-4.081v-2.017h4.321v2.017a4.683,4.683,0,0,0,2.385,4.081l.851.48a.431.431,0,0,1,.22.376",
    transform: "translate(-144.352 -265.416)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85967",
    "data-name": "Path 85967",
    d: "M248.734,293.9v1.909h-1.08V293.9a.431.431,0,0,0-.22-.376l-.851-.48a4.683,4.683,0,0,1-2.385-4.081v-2.017h1.08v2.017a4.683,4.683,0,0,0,2.385,4.081l.851.48a.431.431,0,0,1,.22.376",
    transform: "translate(-225.678 -265.416)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85968",
    "data-name": "Path 85968",
    d: "M191.482,264.784v1.254a1.081,1.081,0,0,1-1.08,1.081h-4.753a1.081,1.081,0,0,1-1.08-1.081v-1.254Z",
    transform: "translate(-170.587 -244.942)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141635",
    "data-name": "Rectangle 141635",
    width: 4.321,
    height: 0.636,
    transform: "translate(15.278 22.177)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85969",
    "data-name": "Path 85969",
    d: "M148.149,392.5v7.566H133.457V392.5a.433.433,0,0,1,.432-.432h13.828a.434.434,0,0,1,.432.432",
    transform: "translate(-123.365 -362.536)",
    fill: "#343b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85970",
    "data-name": "Path 85970",
    d: "M310.8,392.5v7.566h-.864V392.5a.434.434,0,0,0-.432-.432h.864a.434.434,0,0,1,.432.432",
    transform: "translate(-286.018 -362.536)",
    fill: "#262d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85971",
    "data-name": "Path 85971",
    d: "M133.7,489.09v.865a.434.434,0,0,1-.432.432H116.851a.434.434,0,0,1-.432-.432v-.865a.434.434,0,0,1,.432-.432h16.421a.434.434,0,0,1,.432.432",
    transform: "translate(-107.623 -451.781)",
    fill: "#262d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85972",
    "data-name": "Path 85972",
    d: "M327.839,489.09v.865a.434.434,0,0,1-.432.432h-.864a.434.434,0,0,0,.432-.432v-.865a.434.434,0,0,0-.432-.432h.864a.434.434,0,0,1,.432.432",
    transform: "translate(-301.758 -451.781)",
    fill: "#171c23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85973",
    "data-name": "Path 85973",
    d: "M172.223,415.223v3.026a.434.434,0,0,1-.432.432h-9.507a.434.434,0,0,1-.432-.432v-3.026a.433.433,0,0,1,.432-.432h9.507a.434.434,0,0,1,.432.432",
    transform: "translate(-149.599 -383.534)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85974",
    "data-name": "Path 85974",
    d: "M251.821,264.784v1.254a1.081,1.081,0,0,1-1.08,1.081h-.864a1.081,1.081,0,0,0,1.08-1.081v-1.254Z",
    transform: "translate(-230.925 -244.942)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85975",
    "data-name": "Path 85975",
    d: "M12.964,55.124H10.8A10.807,10.807,0,0,1,0,44.315V40.64a.864.864,0,0,1,.864-.865h7.13V41.5H1.729v2.81a9.086,9.086,0,0,0,8.908,9.077Z",
    transform: "translate(-0.063 -37.054)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85976",
    "data-name": "Path 85976",
    d: "M112.038,17.046v.865c0,10.506-4.74,19.024-10.587,19.024S90.864,28.417,90.864,17.911v-.865Z",
    transform: "translate(-84.013 -16.055)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85977",
    "data-name": "Path 85977",
    d: "M80.6,41.5h-.864q-.065-.853-.086-1.729h.864q.023.876.086,1.729",
    transform: "translate(-73.65 -37.054)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85978",
    "data-name": "Path 85978",
    d: "M130.121,219.7h-.864a13.769,13.769,0,0,1-1.366-1.794,8.925,8.925,0,0,0,.905.063,13.676,13.676,0,0,0,1.324,1.732",
    transform: "translate(-118.222 -201.632)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85979",
    "data-name": "Path 85979",
    d: "M191.482,264.784v.432a6.277,6.277,0,0,1-6.914,0v-.432a6.277,6.277,0,0,0,6.914,0",
    transform: "translate(-170.587 -244.942)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85980",
    "data-name": "Path 85980",
    d: "M247.2,17.046v.865c0,10.178-4.449,18.49-10.043,19,5.436-.517,7.45-8.827,7.45-19v-.865Z",
    transform: "translate(-219.173 -16.055)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85981",
    "data-name": "Path 85981",
    d: "M100,1.081a1.077,1.077,0,0,1-1.08,1.081H77.746a1.081,1.081,0,1,1,0-2.162H98.921A1.081,1.081,0,0,1,100,1.081",
    transform: "translate(-70.895 -0.306)",
    fill: "#e8a615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85982",
    "data-name": "Path 85982",
    d: "M112.038,28.41c0,.29,0,.577-.011.865H90.875c-.006-.287-.011-.575-.011-.865Z",
    transform: "translate(-84.013 -26.554)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85983",
    "data-name": "Path 85983",
    d: "M341.358,1.081a1.077,1.077,0,0,1-1.08,1.081H337.9A1.081,1.081,0,0,0,337.9,0h2.377a1.081,1.081,0,0,1,1.08,1.081",
    transform: "translate(-312.252 -0.306)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85984",
    "data-name": "Path 85984",
    d: "M188.751,415.223v3.026a.434.434,0,0,1-.432.432h-8.578c1.746-.035,7.5-.406,7.5-3.891h1.08a.434.434,0,0,1,.432.432",
    transform: "translate(-166.127 -383.534)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85985",
    "data-name": "Path 85985",
    d: "M167.531,422.419V420.65a.177.177,0,0,1,.177-.177h3.874s-3.079.324-4.051,1.946",
    transform: "translate(-154.846 -388.784)",
    fill: "#fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85986",
    "data-name": "Path 85986",
    d: "M139.846,399.691v-1.769a.177.177,0,0,1,.177-.177H143.9s-3.079.324-4.051,1.946",
    transform: "translate(-129.268 -367.785)",
    fill: "#4e5868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85987",
    "data-name": "Path 85987",
    d: "M112.916,67.784c-2.346,0-8.854-4.953-9.643-16.646h2.567c.646,14.307,7.076,16.646,7.076,16.646",
    transform: "translate(-95.477 -47.552)",
    fill: "#fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85988",
    "data-name": "Path 85988",
    d: "M170.37,322.952s3.025-1.946,3.025-4.756v4.756Z",
    transform: "translate(-157.469 -294.29)",
    fill: "#fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85989",
    "data-name": "Path 85989",
    d: "M83.425,5.682v.649h-1.08a.649.649,0,0,1,.648-.649Z",
    transform: "translate(-76.142 -5.555)",
    fill: "#fc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85990",
    "data-name": "Path 85990",
    d: "M354.032,39.775c-.015.584-.043,1.161-.089,1.729H352.1l.216-1.729Z",
    transform: "translate(-325.369 -37.054)",
    fill: "#b7791d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85991",
    "data-name": "Path 85991",
    d: "M300.5,218.248a14.08,14.08,0,0,1-1.35,1.768h-1l.765-.787.914-.945c.227,0,.452-.017.674-.037",
    transform: "translate(-275.524 -201.947)",
    fill: "#b7791d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner1);
export default __webpack_public_path__ + "static/media/winner1.a55943f3710b160f5ad42d9dc6c573fa.svg";
export { ForwardRef as ReactComponent };